<style scoped>
.paginationBlock {
  justify-content: space-between;
  display: flex;
  margin-top: 2%;
  padding: 1% 5px 1% 5px;
  align-items: center;
}
.m-0 {
  margin: 0;
}
</style>
<template>
  <div class="paginationBlock" v-if="totalRecords > 0">
    <p class="span-0">
      <span>{{$t("pagination.total_records")}}: </span>
      <strong class="totalRecords">{{ totalRecords }}</strong>
    </p>
    <v-paginate
      v-if="totalRecords > static_vars.limitPerPage"
      v-model="page"
      :pages="Math.ceil(totalRecords / static_vars.limitPerPage)"
      :range-size="1"
      :hideFirstButton="true"
      :hideLastButton="true"
      active-color="#DCEDFF"
      @update:modelValue="fetchData"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
    };
  },
  props: ["totalRecords", "pageNo"],
  methods: {
    fetchData(pageNum) {
      this.$parent.page = pageNum;
      try {
        this.$parent.listing();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
